module.exports = __webpack_public_path__ + "img/20200508_174134.6aebdb69.jpg";